import { useCallback, useEffect, useRef, useState } from "react";

/**
 * Ported from frontend-st/src/components/captcha/recaptcha.component.js.
 * Tracks a single ReCAPTCHA token and auto-clears it after ~110s so a
 * stale token doesn't trip Google's 2-minute server-side expiration.
 */
export default function useRecaptcha() {
  const [captchaToken, setCaptchaToken] = useState("");
  const recaptchaRef = useRef(null);

  const handleRecaptcha = useCallback((token) => {
    setCaptchaToken(token || "");
  }, []);

  useEffect(() => {
    if (!captchaToken) return undefined;

    const timeout = setTimeout(() => {
      if (recaptchaRef.current) {
        recaptchaRef.current.reset();
      }
      setCaptchaToken("");
    }, 110000);

    return () => clearTimeout(timeout);
  }, [captchaToken]);

  return { captchaToken, setCaptchaToken, recaptchaRef, handleRecaptcha };
}
